const hasText = value => typeof value === 'string' && value.trim() !== '';

const concatAddressParts = (...parts) => parts
  .filter(hasText)
  .join(', ');

export const normalizeUcrsAddressOnLoad = (address) => {
  if (address == null) {
    return address;
  }

  const mergedLine1 = concatAddressParts(address.line1, address.line2);

  return {
    ...address,
    line1: mergedLine1 || address.line1 || '',
    line2: ''
  };
};

const splitByFirstComma = (value) => {
  if (typeof value !== 'string') {
    return ['', ''];
  }

  const commaIndex = value.indexOf(',');
  if (commaIndex === -1) {
    return [value.trim(), ''];
  }

  return [
    value.slice(0, commaIndex).trim(),
    value.slice(commaIndex + 1).trim()
  ];
};

export const normalizeUcrsAddressOnSave = (address) => {
  if (address == null) {
    return address;
  }

  const [line1, line2] = splitByFirstComma(address.line1);

  return {
    ...address,
    line1,
    line2
  };
};

export const normalizeUcrsValuesOnSave = (
  formValues,
  {
    residenceAddressKey = 'residenceAddress',
    mailingAddressKey,
    mailingAddressesArrayKey,
    headOfficeAddressKey,
    partnerAddressKey
  } = {}
) => {
  if (formValues?.customer == null) {
    return formValues;
  }

  const customer = {
    ...formValues.customer,
    [residenceAddressKey]: normalizeUcrsAddressOnSave(formValues.customer[residenceAddressKey])
  };

  if (mailingAddressesArrayKey != null) {
    customer[mailingAddressesArrayKey] = (formValues.customer[mailingAddressesArrayKey] || [])
      .map(normalizeUcrsAddressOnSave);
  }

  if (mailingAddressKey != null) {
    customer[mailingAddressKey] = normalizeUcrsAddressOnSave(formValues.customer[mailingAddressKey]);
  }

  if (headOfficeAddressKey != null) {
    customer[headOfficeAddressKey] = normalizeUcrsAddressOnSave(formValues.customer[headOfficeAddressKey]);
  }

  if (partnerAddressKey != null) {
    customer[partnerAddressKey] = normalizeUcrsAddressOnSave(formValues.customer[partnerAddressKey]);
  }

  return {
    ...formValues,
    customer
  };
};

export const normalizeUcrsInitialValuesOnLoad = (
  formByIdResponse,
  {
    residenceAddressKey = 'residenceAddress',
    mailingAddressKey,
    mailingAddressesArrayKey,
    headOfficeAddressKey,
    partnerAddressKey
  } = {}
) => {
  if (formByIdResponse?.customer == null) {
    return formByIdResponse;
  }

  const customer = {
    ...formByIdResponse.customer,
    [residenceAddressKey]: normalizeUcrsAddressOnLoad(formByIdResponse.customer[residenceAddressKey])
  };

  if (mailingAddressesArrayKey != null) {
    customer[mailingAddressesArrayKey] = (formByIdResponse.customer[mailingAddressesArrayKey] || [])
      .map(normalizeUcrsAddressOnLoad);
  }

  if (mailingAddressKey != null) {
    customer[mailingAddressKey] = normalizeUcrsAddressOnLoad(formByIdResponse.customer[mailingAddressKey]);
  }

  if (headOfficeAddressKey != null) {
    customer[headOfficeAddressKey] = normalizeUcrsAddressOnLoad(formByIdResponse.customer[headOfficeAddressKey]);
  }

  if (partnerAddressKey != null) {
    customer[partnerAddressKey] = normalizeUcrsAddressOnLoad(formByIdResponse.customer[partnerAddressKey]);
  }

  return {
    ...formByIdResponse,
    customer
  };
};
